export default __webpack_public_path__ + "static/media/2338.9e3a7300.png";